import { zipObj } from 'ramda';

export const apiNameEnums = [
  'JOURNEY_BUILDER_DECISION_SPLIT_GET_DYNAMIC_LIST_OBJECT_FIELDS',
  'JOURNEY_BUILDER_DECISION_SPLIT_GET_LOCALIZED_FIELDS',
  'JOURNEY_BUILDER_DECISION_SPLIT_GET_OBJECTS',
  'JOURNEY_BUILDER_DECISION_SPLIT_GET_OBJECT_FIELDS',
  'JOURNEY_BUILDER_DECISION_SPLIT_GET_USER_DATA',
  'JOURNEY_BUILDER_GET_LOCALIZATION',
  'JOURNEY_BUILDER_JOURNEY_GET_HCO_ENABLED',
  'JOURNEY_BUILDER_JOURNEY_GET_METADATA',
];

//this creates an object where key and value are the same string as in the above array
const enums = zipObj(apiNameEnums, apiNameEnums);

export default enums;



// WEBPACK FOOTER //
// ./src/Enums/apiNames.js